import React, { Component } from 'react';
// import { Link, Redirect } from 'react-router-dom';
import 'react-widgets/dist/css/react-widgets.css';
import { DropdownList } from 'react-widgets';
import { schools } from '../variables/schoolList';
import carreras from '../variables/carreras.json';

export default class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('tpuser')),
      error: false,
      success: false,
      isEditing: false,
      ciudad: '',
      carreras: carreras,
    };

    // this.toggleEdit = this.toggleEdit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    // this.apiUpdateUser = this.apiUpdateUser.bind(this);

    // Fast redirection?
    if (!this.state.user || !this.state.user.token)
      window.location.replace('/login');
  }

  componentDidMount() {
    this.userData();
  }

  handleChange(event) {
    const name = event.target.name;
    const user = this.state.user;
    user[name] = event.target.value;
    console.log({ name: user[name] });
    this.setState({ user: user });
  }

  handleSubmit(event) {
    event.preventDefault();
    console.log(this);
    this.apiUpdateUser();
  }

  userData() {
    console.log(this.state.user);
    fetch(process.env.REACT_APP_API_URL + '/users/me', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.state.user.token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log('desde API', data);
        this.setState({ user: { ...this.state.user, ...data } });
        console.log(this.state.user);
      })
      .catch((err) => console.log(err));
  }

  // toggleEdit(){ this.setState( {isEditing: !this.state.isEditing} ) }

  apiUpdateUser() {
    let self = this;
    console.log(self.state);
    fetch(process.env.REACT_APP_API_URL + '/users/me', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + self.state.user.token,
      },
      body: JSON.stringify({ user: self.state.user }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data._id) {
          let newUser = { ...this.state.user, ...data };
          localStorage.setItem('tpuser', JSON.stringify(newUser));
          self.setState({ user: newUser, success: true });
        } else {
          self.setState({ error: true });
        }
      })
      .catch((err) => console.log(err));
  }

  render() {
    const { user, carreras } = this.state;

    const alertError = this.state.error ? (
      <div className='alert alert-danger'> Oops! </div>
    ) : (
      ''
    );
    const alertOk = this.state.success ? (
      <div className='alert alert-success'> Cambios realizados con éxito </div>
    ) : (
      ''
    );

    const carrerasOps = carreras[user.ciudad]
      ? carreras[user.ciudad].map((c) => {
          return (
            <option key={`carr-${c.id}`} value={c.id}>
              {c.name}
            </option>
          );
        })
      : [];

    return (
      <div id='user' className='container'>
        <div className='row'>
          <div className='col-12 col-lg-6 offset-lg-3'>
            <h1 className='upper title margin-bot-20'>Mi Perfil</h1>
            <form>
              {alertError}
              {alertOk}

              <div className='form-row'>
                <div className='form-group col'>
                  <input
                    className='form-control form-control'
                    name='name'
                    value={this.state.user.name}
                    onChange={this.handleChange}
                    placeholder='Nombre'
                  />
                </div>
              </div>

              <div className='form-row'>
                <div className='form-group col'>
                  <input
                    className='form-control form-control'
                    name='lastname'
                    value={this.state.user.lastname}
                    onChange={this.handleChange}
                    placeholder='Apellido Paterno'
                  />
                </div>
                <div className='form-group col'>
                  <input
                    className='form-control form-control'
                    name='lastname_mat'
                    value={this.state.user.lastname_mat}
                    onChange={this.handleChange}
                    placeholder='Apellido Materno'
                  />
                </div>
              </div>

              <div className='form-row'>
                <div className='form-group col'>
                  <input
                    className='form-control form-control'
                    name='rut'
                    value={this.state.user.rut}
                    onChange={this.handleChange}
                    placeholder='RUT'
                  />
                </div>
                <div className='form-group col-1'>-</div>
                <div className='form-group col-3'>
                  <input
                    className='form-control form-control'
                    name='dv'
                    value={this.state.user.dv}
                    onChange={this.handleChange}
                    placeholder='DV'
                  />
                </div>
              </div>

              <div className='form-row'>
                <div className='form-group col'>
                  <input
                    className='form-control form-control'
                    name='email'
                    value={this.state.user.email}
                    onChange={this.handleChange}
                    placeholder='Email'
                  />
                </div>
              </div>

              <div className='form-row'>
                <div className='form-group col'>
                  <input
                    className='form-control form-control'
                    name='mobile'
                    value={this.state.user.mobile}
                    onChange={this.handleChange}
                    placeholder='Teléfono'
                  />
                </div>
                <div className='form-group col'>
                  <select
                    className='form-control form-control'
                    name='sex'
                    value={this.state.user.sex}
                    onChange={this.handleChange}>
                    <option value=''>Selecciona tu género</option>
                    <option value='male'>Masculino</option>
                    <option value='female'>Femenino</option>
                  </select>
                </div>
              </div>

              <div className='form-row'>
                <div className='form-group col'>
                  <DropdownList
                    name='school'
                    placeholder='Busca tu establecimiento...'
                    data={schools}
                    value={this.state.user.school}
                    valueField='value'
                    textField='text'
                    filter='contains'
                    minLength={3}
                    onChange={(e) =>
                      this.handleChange({
                        target: { name: 'school', value: e.value },
                      })
                    }
                    onSearch={() => {
                      this.setState({ filtering: true });
                      setTimeout(
                        () => this.setState({ filtering: false }),
                        1000
                      );
                    }}
                    busy={this.state.filtering}
                  />
                </div>
              </div>

              <div className='form-row'>
                <div className='form-group col'>
                  <select
                    className='form-control form-control'
                    name='ciudad'
                    value={this.state.user.ciudad}
                    onChange={this.handleChange}>
                    <option value=''>¿Dónde quieres estudiar?</option>
                    <option value='santiago'>Santiago</option>
                    <option value='temuco'>Temuco</option>
                  </select>
                </div>
              </div>

              <div className='form-row'>
                <div className='form-group col'>
                  <select
                    className='form-control form-control'
                    name='carrera1'
                    value={this.state.user.carrera1}
                    disabled={carrerasOps.length > 0 ? false : true}
                    onChange={this.handleChange}>
                    <option value=''>Preferencia 1</option>
                    {carrerasOps}
                  </select>
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col'>
                  <select
                    className='form-control form-control'
                    name='carrera2'
                    value={this.state.user.carrera2}
                    disabled={carrerasOps.length > 0 ? false : true}
                    onChange={this.handleChange}>
                    <option value=''>Preferencia 2</option>
                    {carrerasOps}
                  </select>
                </div>
              </div>
              <div className='form-row'>
                <div className='form-group col'>
                  <select
                    className='form-control form-control'
                    name='carrera3'
                    value={this.state.user.carrera3}
                    disabled={carrerasOps.length > 0 ? false : true}
                    onChange={this.handleChange}>
                    <option value=''>Preferencia 3</option>
                    {carrerasOps}
                  </select>
                </div>
              </div>

              <div className='form-row'>
                <div className='form-group col'>
                  <input
                    className='form-control form-control'
                    name='pass'
                    onChange={this.handleChange}
                    type='password'
                    placeholder='Contraseña'
                  />
                </div>
              </div>

              <button
                className='btn btn-lg btn-black float-right mb-5'
                onClick={this.handleSubmit}>
                Guardar
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/User.jsx